import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { SERVER_URL } from "../constants/variables";
import ayekartLogo from "../assets/images/ayekartLogo.png";

export default class ResetPasswordWithTokenComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      token: null,
      success: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    // Handle duplicate token params (e.g. ?token=&token=abc123) - use first non-empty
    const tokenValues = params.getAll("token");
    const token = tokenValues.find((t) => t && t.trim()) || params.get("token") || null;
    if (!token) {
      toast.error("Invalid or missing reset link");
      this.setState({ token: null });
    } else {
      this.setState({ token });
    }
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onSubmit = () => {
    const { token, newPassword, confirmPassword } = this.state;
    const pwdRegex =
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|":<>[\]\\' ~_]).{8,}/;

    if (!token) {
      toast.error("Invalid reset link");
      return;
    }
    if (!newPassword.trim()) {
      toast.error("Please enter a new password");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (!pwdRegex.test(newPassword)) {
      toast.error(
        "Password must contain: one uppercase, one lowercase, one digit, one special character, and be at least 8 characters"
      );
      return;
    }

    toast.loading("Updating password...", { duration: 2000 });
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token,
        new_password: newPassword,
      }),
    };
    fetch(SERVER_URL + "/users/reset-password-with-token", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          toast.success("Password reset successfully");
          this.setState({ success: true, newPassword: "", confirmPassword: "" });
        } else {
          toast.error(result.message || "Something went wrong");
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
      });
  };

  render() {
    const { token, success } = this.state;

    if (!token && !success) {
      return (
        <Container>
          <Row>
            <Col sm></Col>
            <Col sm>
              <div>
                <img src={ayekartLogo} className="img-fluid" alt="ayekartLogo" />
              </div>
              <h4 style={{ textAlign: "center" }}>Invalid Reset Link</h4>
              <p style={{ textAlign: "center" }}>
                This link is invalid or has expired. Please request a new
                password reset.
              </p>
              <div style={{ textAlign: "center" }}>
                <Link to="/forgot-password">Request New Link</Link>
                {" | "}
                <Link to="/login">Back to Login</Link>
              </div>
            </Col>
            <Col sm></Col>
          </Row>
        </Container>
      );
    }

    if (success) {
      return (
        <Container>
          <Row>
            <Col sm></Col>
            <Col sm>
              <div>
                <img src={ayekartLogo} className="img-fluid" alt="ayekartLogo" />
              </div>
              <h4 style={{ textAlign: "center" }}>Password Reset Successfully</h4>
              <p style={{ textAlign: "center" }}>
                You can now log in with your new password.
              </p>
              <div style={{ textAlign: "center" }}>
                <Link to="/login">Go to Login</Link>
              </div>
            </Col>
            <Col sm></Col>
          </Row>
        </Container>
      );
    }

    return (
      <Container>
        <Row>
          <Col sm></Col>
          <Col sm>
            <div>
              <img src={ayekartLogo} className="img-fluid" alt="ayekartLogo" />
            </div>
            <h4 style={{ textAlign: "center" }}>Reset Password</h4>
            <p style={{ color: "#666" }}>
              Password should contain: uppercase, lowercase, digit, special
              character, min 8 characters
            </p>
            <Form>
              <FormGroup>
                <Label for="newPassword">New Password</Label>
                <Input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  placeholder="Enter new password"
                  value={this.state.newPassword}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup>
                <Label for="confirmPassword">Confirm Password</Label>
                <Input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm new password"
                  value={this.state.confirmPassword}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <Button color="primary" block onClick={this.onSubmit}>
                Reset Password
              </Button>
              <div style={{ marginTop: "1rem", textAlign: "center" }}>
                <Link to="/login">Back to Login</Link>
              </div>
            </Form>
          </Col>
          <Col sm></Col>
        </Row>
      </Container>
    );
  }
}
